// extracted by mini-css-extract-plugin
export default {"textarea":"SimpleTextEditor-modules__textarea__Gqt6e","empty":"SimpleTextEditor-modules__empty__n4ZGD","focused":"SimpleTextEditor-modules__focused___KVUa"};